//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {VueShowdown} from 'vue-showdown'
import axios from 'axios'
import AppLogo from "./components/AppLogo"
import AccountIcon from 'vue-material-design-icons/AccountOutline'
import BellIcon from 'vue-material-design-icons/BellOutline'
import CartIcon from 'vue-material-design-icons/CartOutline'
import ExitIcon from 'vue-material-design-icons/ExitToApp'
import BankOutline from 'vue-material-design-icons/BankOutline'
import FrameworkIcons from '@/assets/images/icons.svg?raw';

import NavBar from "./components/NavBar";
import Tiles from "./components/Tiles";
import AppNotices from "./components/AppNotices";
import AppCart from "./components/AppCart";
import {updateUrl} from './utils'
import OrganizationsSelect from "@/components/OrganizationsSelect";
import AppButton from './components/AppButton.vue';

const MAIN_PAGE_SWITCHER_FLAG_NAME = "MainPageSwitcher";

export default {
  name: 'App',

  props: {
    auth: {
      required: true,
    },
    menu: {
      required: false,
    },
    rest: {
      required: false,
    },
    config: {
      required: false,
    },
    locale: {
      required: false,
    },
    orgManager: {
      required: false,
    },
    retrieveInfo: {
      required: false,
    },
  },
  provide() {
    return {
      httpClient: this.httpClient,
      baseUrl: this.baseUrl,
      cmsBaseUrl: this.cmsBaseUrl,
    }
  },
  components: {
    AppButton,
    OrganizationsSelect,
    Tiles,
    NavBar,
    AppLogo,
    AccountIcon,
    BellIcon,
    CartIcon,
    ExitIcon,
    BankOutline,
    AppNotices,
    AppCart,
    VueShowdown,
  },

  data: () => ({
    path: '/',
    app: null,
    breadCrumbs: [],
    appMenu: [],
    menuStrapi: [],
    blocks: [],
    currentMenu: {},
    scopes: {},
    featureFlags: [],
    showOrgSelect: false,
    showCart: false,
    selectedSection: null,
    selectedOrganization: null,
    axiosInstance: axios.create({
      headers: {
        PassportId: process.env.VUE_APP_DEFAULT_PASSPORT_ID,
      }
    }),
    FrameworkIcons,
    isNewPlatformAlertClosed: false,
    showSenddocumentsAlert: false,
    showContinueRegistrationAlert: false,
  }),

  computed: {
    showNewPlatformAlert() {
      if (this.isNewPlatformAlertClosed) {
        return false;
      }
      const hasMainPageSwithcherFeatureFlag = this.featureFlags.find((flag) => flag.name === MAIN_PAGE_SWITCHER_FLAG_NAME)?.value;
      const isEnabledNewUIApp = ['mb-app-logins-management', 'mb-app-logins-management-next'].every(app => !this.path?.startsWith(this.menu?.[app]?.path));
      return hasMainPageSwithcherFeatureFlag && isEnabledNewUIApp;
    },
    hasUser() {
      return Boolean(this.auth && this.auth.user)
    },
    username() {
      if (this.hasUser) {
        return this.auth.user.name || this.auth.user.email || ''
      }
      return ''
    },
    cmsBaseUrl() {
      return this.config?.original?.CMS_SERVER || process.env.VUE_APP_CMS_SERVER
    },
    moexUrl() {
      return this.config?.original?.MOEX_URL || process.env.VUE_APP_MOEX_URL
    },
    passportUrl() {
      return this.config?.original?.PASSPORT_URL || process.env.VUE_APP_PASSPORT_URL
    },
    baseUrl() {
      return this.config?.original?.API_SERVER || process.env.VUE_APP_BASE_URL
    },
    httpClient() {
      return this.rest || this.axiosInstance
    },
    isMainPage() {
      return this.path === '/'
    },
    lang() {
      return this.$i18n && this.$i18n.locale && this.$i18n.locale.toLowerCase() || 'ru'
    },
    orgTitle() {
      if (this.selectedOrganization) {
        const names = {
          ru: 'shortName',
          en: 'shortNameEn',
        }
        return this.selectedOrganization[names[this.lang]]
      }
      return null
    },
    showTooltip() {
      return Boolean(this.orgTitle && this.orgTitle.length > 55)
    },
    allowedApplications() {
      const apps = Object.keys(this.menu)
      apps.push('mb-app-iframe-viewer')
      return apps
    },
    titleChangeEvent() {
      const menu = this.breadCrumbs.length ? this.breadCrumbs.slice(-1)[0] : {title: ''}
      const title = menu.app === 'mb-app-iframe-viewer' ? menu.title : ''
      return new CustomEvent("title:change", {
        bubbles: false,
        cancelable: false,
        composed: true,
        detail: {
          title
        },
      })
    },
    showHeaderCryptoapiButton() {
      const flagName = "showHeaderCryptoapiButton";
      return this.featureFlags.find(item => item.name === flagName)?.value;
    },
  },

  watch: {
    '$i18n.locale'() {
      if (this.hasUser) {
        this.getMenu();
        this.getBlocks();
      }
    },
  },

  async created() {
    let params = new URLSearchParams(location.search)
    const lang = params.get('lang')
    if (lang) {
      this.setLocale(lang)
    }
    if (this.hasUser) {
      await this.getBlocks()
      await this.getMenu()
      await this.getScopes()
      this.setTitle()
    }
    if (this.retrieveInfo?.stage === 'registration_finished' && this.scopes?.lku?.length) {
      this.showSenddocumentsAlert = true;
    } else if (this.retrieveInfo?.isSkippedRegistration) {
      this.showContinueRegistrationAlert = true;
    }
  },

  async mounted() {
    if (this.hasUser) {
      this.getFeatureFlags()
      window.addEventListener('single-spa:routing-event', () => {
        this.updateMenu()
        this.buildBreadCrumbs()
        this.checkAndSetMenu()
        this.setTitle()
      });
    }
  },

  methods: {
    setTitle() {    
      if (this.path === "/") {
        localStorage.setItem("mb-title", "");
        return
      }
      const KEYWORDS = ["hamburger", "list", "children"];
      let currentName = "";
      const notValidSPAlink = (url) => !url || (url && !url.startsWith("/"));

      const parseLink = (item, urlKeyName = "path") => {
        if (currentName) return;            
        for (const key of KEYWORDS) {
          if (!item[key] || !item[key].length) continue;
          const page = item[key].find((link) => {
            parseLink(link, urlKeyName);
            if (notValidSPAlink(link[urlKeyName])) return;
            return link[urlKeyName] && this.path.endsWith(link[urlKeyName]);
          });
          
          if (page) {
            currentName = page.title;
            return;
          }
        }
      };  
      

      this.menuStrapi.forEach((el) => parseLink(el));
      this.blocks.forEach((el) => parseLink(el,'url'));
      
      localStorage.setItem("mb-title", currentName);      
    },
    async getScopes() {
      try {
        const {data} = await this.httpClient.get(`${this.baseUrl}/shared/permissions/scopes`)
        if (data.data) {
          for (let key in data.data) {
            data.data[key] = data.data[key].sort((a,b) => (a.shortName > b.shortName ? 1 : -1))
          }
          this.$set(this, 'scopes', data.data)
        }
      } catch (e) {
        if (!e.response || e.response.status !== 401) {
          this.scopes = {}
        }
      }
    },
    async getFeatureFlags() {
      try {
        const {data} = await this.httpClient.get(`${this.cmsBaseUrl}/feature-flags`);
        this.featureFlags = data.data;
      } catch (e) {
        this.featureFlags = [];
      }
    },
    async getMenu() {
      const params = {
        locale: this.$i18n.locale
      }
      const {data} = await this.httpClient.get(`${this.cmsBaseUrl}/menus`, {params})
      if (data.data) {
        this.menuStrapi = this.mergeMenu(data.data)
        this.path = location.pathname
        this.checkAndSetMenu()
        this.buildBreadCrumbs()
      }
    },
    prepareArray(arr) {
      return arr.reduce((acc, el) => {
        if (el.isActive && (this.allowedApplications.includes(el.application) || (!el.application && el.children && el.children.length))) {
          if (this.menu && this.menu[el.application]) {
            el.title = this.menu[el.application].title[this.lang]
            el.path = this.menu[el.application].path
            el.children = this.menu[el.application].items.map(item => {
              const copy = {...item}
              copy.title = item.title[this.lang]
              copy.id = Math.random().toString(36).slice(2, 10)
              return copy
            })
          } else if (el.children) {
            el.children = el.children.filter(child => child.isActive)
            if (el.children.length) {
              el.children = this.prepareArray(el.children)
            }
          }
          acc.push(el)
        }
        return acc
      }, [])
    },
    mergeMenu(data) {
      return data.map(item => {
        item.list = this.prepareArray(item.list)
        item.hamburger = this.prepareArray(item.hamburger)
        return item
      })
    },
    updateMenu() {
      this.path = location.pathname
      const mainEl = document.getElementById('apps-main-container')
      if (this.isMainPage && mainEl) {
        mainEl.style.display = "none";
      } else if (mainEl) {
        mainEl.style.display = "block";
      }
    },
    setCurrentMenu(code) {
      this.currentMenu = this.menuStrapi.find(item => item.code === code)
      this.selectedSection = code
    },
    findTile(path) {
      let code = null
      let root = null
      let menu = null

      const prefix = path.startsWith('/pages') ? '/pages' : ''
      for (const item of this.menuStrapi) {
        const stack = [...item.list, ...item.hamburger]
        while (stack.length) {
          const node = stack.pop()
          if (prefix + node.path === path) {
            menu = node
            root = item
            code = item.code
            break
          }
          if (node.children) {
            stack.push(...node.children)
          }
        }
      }
      return {code, root, menu}
    },
    checkAndSetMenu() {
      if (!this.isMainPage) {
        let {code} = this.findTile(this.path)
        if (!code) {
          const data = this.findTile(this.path.split('/').slice(0, -1).join('/'))
          code = data.code
        }
        if (code) {
          this.setCurrentMenu(code)
          this.selectedSection = code
        } else {
          const tile = this.findBlockByPath()
          if (tile) {
            this.selectedSection = tile.code
          }
        }
      }
    },
    buildBreadCrumbs() {
      this.breadCrumbs = []
      if (!this.isMainPage) {
        let {root, menu, code} = this.findTile(this.path)
        if (!root && !menu && !code) {
          const data = this.findTile(this.path.split('/').slice(0, -1).join('/'))
          root = data.root
          menu = data.menu
          code = data.code
        }
        const result = []
        let tile = null

        if (root) {
          const flattened = []
          const flatMenu = (node) => {
            if (node.children) {
              node.children.forEach(child => {
                child.id = Math.random().toString(36).slice(2, 10)+'__'+child.id
                child.parentId = node.id
                flattened.push(child)
                flatMenu(child, node.id)
              })
            }
          }

          root.children = [...root.list, ...root.hamburger]
          flatMenu(root)

          let id = menu.id
          while (id !== null) {
            const menu = flattened.find(item => item.id === id)
            if (menu) {
              result.unshift({
                title: menu.title,
                url: menu.path,
                active: !(menu.children && menu.children.length) && menu.path && menu.application,
                app: menu.application,
              })
              id = menu.parentId
            } else {
              id = null
            }
          }
          for (const block of this.blocks) {
            const foundedTile = block.list.find(item => item.code === root.code)
            if (foundedTile) {
              tile = foundedTile
              break
            }
          }
        } else {
          const baseAppPath = this.path.substring(1, this.path.length).split('/')[0]

          for (const block of this.blocks) {
            const foundedTile = block.list.find(item => (item.url === this.path) || (baseAppPath && item.url === `/${baseAppPath}`))
            if (foundedTile) {
              tile = foundedTile
              break
            }
          }
        }
        if (tile) {
          result.unshift({
            title: tile.title,
            url: tile.url,
            active: !!(tile.url && tile.url.length),
            app: null,
          })
        }
        result.unshift({
          title: this.$t('homePage'),
          url: '/',
          active: true,
          app: null,
        })
        this.breadCrumbs = result
        window.dispatchEvent(this.titleChangeEvent)
      }
    },
    async getBlocks() {
      const {data} = await this.httpClient.get(`${this.cmsBaseUrl}/cabinet-links`, {
        params: {
          locale: this.$i18n.locale
        }
      })
      if (data.data) {
        this.blocks = data.data
      }
    },
    findBlockByPath() {
      for (const block of this.blocks) {
        const tile = block.list.find(item => item.url === this.path)
        if (tile) {
          return tile
        }
      }
      return null
    },
    setOrganization(org) {
      this.selectedOrganization = org
      this.orgManager.setOrganization(org)
      this.showOrgSelect = false
    },
    goToCryptoApiCheck() {
      window.singleSpaNavigate('/ca-check')
    },
    goToHomepage() {
      this.setOrganization(null)
      this.selectedSection = null
      window.singleSpaNavigate('/')
      updateUrl(this.$i18n);
      if (!this.hasUser) {
        location.reload()
      }
    },
    navigateCrumbs(item) {
      window.singleSpaNavigate(item.url)
      updateUrl(this.$i18n);
    },
    navigateToNewPlatform() {
      window.singleSpaNavigate(this.config?.original?.PLATFORM_URL || process.env.VUE_APP_PLATFORM_URL)
    },
    navigateToSenddocuments() {
      window.singleSpaNavigate("/senddocuments")
      updateUrl(this.$i18n);
      this.closeSenddocumentsAlert();
    },
    async handleContinueRegistration() {
      try {
        await this.httpClient.put(`${this.baseUrl}/shared/registration/stages/skip`, { data: { isSkipped: false } });
        this.closeContinueRegistrationAlert();
        window.location.href = "/";
      } catch (e) {
        console.error(this.$t('backToRegistrationFailedText'), e);
      }
    },
    closeNewPlatformAlert() {
      this.isNewPlatformAlertClosed = true;
    },
    closeSenddocumentsAlert() {
      this.showSenddocumentsAlert = false;
    },
    closeContinueRegistrationAlert() {
      this.showContinueRegistrationAlert = false;
    },
    setLocale(lang) {
      this.$i18n.locale = lang
      if (this.locale) {
        this.locale.lang = lang
      }
      updateUrl(this.$i18n);
    },
    redirectToSubscription() {
      const flagNameNotification = "Notifications";
      const isNotifications = this.featureFlags.find(item => item.name === flagNameNotification)?.value;
      if (isNotifications) {
        window.singleSpaNavigate("/notify");
      } else {
        window.open(`${this.passportUrl}/subscriptions`, '_blank').focus();
      }
    },
    logout() {
      localStorage.removeItem('CabinetCompanyLKEOrgId')
      this.auth.logout()
    }
  }
}
